module.exports = __webpack_public_path__ + "img/kobelink_logo.7726e35a.png";